import React from 'react';
import { SidebarHeader } from './SidebarHeader';
import { SidebarNavigation } from './SidebarNavigation';
import { SidebarFooter } from './SidebarFooter';
import { SidebarUpgrade } from './SidebarUpgrade';

interface SidebarProps {
  isAdmin: boolean;
  isPremium?: boolean;
  isCollapsed: boolean;
  isMobileMenuOpen: boolean;
  onToggleCollapse: () => void;
  onMobileMenuClose: () => void;
  onLogout: () => void;
}

export function Sidebar({ 
  isAdmin, 
  isPremium = false,
  isCollapsed, 
  isMobileMenuOpen, 
  onToggleCollapse,
  onMobileMenuClose,
  onLogout
}: SidebarProps) {
  return (
    <>
      {/* Overlay para fechar o menu no mobile */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-gray-600/50 backdrop-blur-sm z-30 md:hidden"
          onClick={onMobileMenuClose}
        />
      )}
      
      {/* Barra lateral */}
      <aside
        className={`fixed inset-y-0 left-0 z-40 ${
          isMobileMenuOpen ? 'w-80' : isCollapsed ? 'w-20' : 'w-64'
        } bg-white/90 backdrop-blur-md border-r border-gray-100 transform transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'translate-x-0 top-16' : '-translate-x-full md:translate-x-0 md:top-0'
        } shadow-lg md:shadow-none`}
      >
        <div className="h-full flex flex-col">
          <SidebarHeader 
            isCollapsed={isCollapsed} 
            isMobileMenuOpen={isMobileMenuOpen}
            onToggleCollapse={onToggleCollapse}
          />
          
          <SidebarNavigation 
            isAdmin={isAdmin} 
            isPremium={isPremium}
            isCollapsed={isCollapsed} 
            isMobileMenuOpen={isMobileMenuOpen}
            onNavItemClick={onMobileMenuClose}
          />
          
          <div className="mt-auto">
            {!isAdmin && !isPremium && (
              <SidebarUpgrade 
                isCollapsed={isCollapsed} 
                isMobileMenuOpen={isMobileMenuOpen} 
              />
            )}
            
            <SidebarFooter 
              isCollapsed={isCollapsed} 
              isMobileMenuOpen={isMobileMenuOpen}
              onLogout={onLogout}
            />
          </div>
        </div>
      </aside>
    </>
  );
}